import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Applicant } from '@app/model/applicant';

@Injectable({ providedIn: 'root' })
export class HandleDataService {
  public reScheduleInterview :BehaviorSubject<Applicant>;
  constructor(httpClient: HttpClient) {}
  setReScheduleInterviewDetails(details: any) { 
    this.reScheduleInterview = new BehaviorSubject<Applicant>(details);
  } 
  getReScheduleInterviewDetails(): Observable<any> { 
      return this.reScheduleInterview['_value']; 
  } 
}